import { ReactNode } from 'react';
import { i18next } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { Chip } from '@frontend/design-system';
import { DEVICE_STATE } from './types';

export const DEVICE_STATE_CHIP = {
  [DEVICE_STATE.AVAILABLE]: {
    chip: (
      <Chip leftElement={<Icon name='phone-small' />} variant='success' maxWidth='none'>
        {i18next.t('Available', { ns: 'phone' })}
      </Chip>
    ),
  },
  [DEVICE_STATE.DO_NOT_DISTURB]: {
    chip: (
      <Chip leftElement={<Icon name='moon-small' />} variant='eggplant' maxWidth='none'>
        {i18next.t('Do Not Disturb', { ns: 'phone' })}
      </Chip>
    ),
  },
  [DEVICE_STATE.DISCONNECTED]: {
    chip: (
      <Chip leftElement={<Icon name='phone-missed-small' />} variant='critical' maxWidth='none'>
        {i18next.t('Disconnected', { ns: 'phone' })}
      </Chip>
    ),
  },
  [DEVICE_STATE.OCCUPIED]: {
    chip: (
      <Chip leftElement={<Icon name='phone-call-small' />} variant='tangerine' maxWidth='none'>
        {i18next.t('On Call', { ns: 'phone' })}
      </Chip>
    ),
  },
  [DEVICE_STATE.RINGING]: {
    chip: (
      <Chip leftElement={<Icon name='phone-incoming-small' />} variant='rose' maxWidth='none'>
        {i18next.t('Ringing', { ns: 'phone' })}
      </Chip>
    ),
  },
  [DEVICE_STATE.OFFLINE]: {
    chip: (
      <Chip leftElement={<Icon name='phone-hangup-small' />} variant='neutral' maxWidth='none'>
        {i18next.t('Offline', { ns: 'phone' })}
      </Chip>
    ),
  },
  [DEVICE_STATE.SOFTPHONE_OFFLINE]: {
    chip: (
      <Chip leftElement={<Icon name='phone-hangup-small' />} variant='neutral' maxWidth='none'>
        {i18next.t('Softphone Offline', { ns: 'phone' })}
      </Chip>
    ),
  },
};

export const DEVICE_STATE_OPTIONS = [
  {
    value: DEVICE_STATE.AVAILABLE,
    label: i18next.t('Available', { ns: 'phone' }),
  },
  // {
  //   value: DEVICE_STATE.DO_NOT_DISTURB,
  //   label: i18next.t('Do Not Disturb', { ns: 'phone' }),
  // },
  {
    value: DEVICE_STATE.OCCUPIED,
    label: i18next.t('On Call', { ns: 'phone' }),
  },
  {
    value: DEVICE_STATE.SOFTPHONE_OFFLINE,
    label: i18next.t('Softphone Offline', { ns: 'phone' }),
  },
];

export const CARD_TYPE_OPTIONS = [
  {
    value: 'user',
    label: i18next.t('User', { ns: 'phone' }),
  },
  {
    value: 'device',
    label: i18next.t('Device', { ns: 'phone' }),
  },
];

export const USER_STATE_OPTIONS = [
  {
    value: DEVICE_STATE.DISCONNECTED,
    label: i18next.t('Disconnected', { ns: 'phone' }),
  },
  {
    value: 'offline',
    label: i18next.t('Offline', { ns: 'phone' }),
  },
  {
    value: 'online',
    label: i18next.t('Online', { ns: 'phone' }),
  },
  // {
  //   value: 'busy',
  //   label: i18next.t('Busy', { ns: 'phone' }),
  // },
  // {
  //   value: 'away',
  //   label: i18next.t('Away', { ns: 'phone' }),
  // },
];

export const SORT_OPTIONS = [
  {
    value: 'ascending',
    label: i18next.t('A to Z', { ns: 'phone' }),
  },
  {
    value: 'descending',
    label: i18next.t('Z to A', { ns: 'phone' }),
  },
  {
    value: 'recent',
    label: i18next.t('Recently Added'),
  },
];

export const DEVICE_STATE_FILTER_TRAY_OPTIONS: Record<string, ReactNode> = Object.fromEntries(
  DEVICE_STATE_OPTIONS.map((option) => [option.value, DEVICE_STATE_CHIP[option.value].chip])
);

export const CARD_TYPE_FILTER_TRAY_OPTIONS: Record<string, string> = Object.fromEntries(
  CARD_TYPE_OPTIONS.map((option) => [option.value, option.label])
);

export const USER_STATE_FILTER_TRAY_OPTIONS: Record<string, string> = Object.fromEntries(
  USER_STATE_OPTIONS.map((option) => [option.value, option.label])
);

export const SORT_OPTIONS_MAP: Record<string, string> = Object.fromEntries(
  SORT_OPTIONS.map((option) => [option.value, option.label])
);

export const MAX_SELECTED_ENTITIES = 25;
